import * as faceapi from '@vladmandic/face-api';

export default async function getFaceDetectionFromBase64Image(base64 = '') {
  try {
    const _img = await faceapi.fetchImage(base64);
    const _detections = await faceapi
      .detectSingleFace(_img, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks()
      .withFaceDescriptor();
    return _detections;
  } catch (error) {
    console.log('Error getFaceDetectionFromBase64Image', error);
    throw error;
  }
}
